// Single source of truth for form-field typography. Input.tsx and every hand-rolled
// auth-page field (Login, SignUp, InviteSignUp, ForgotPassword, ResetPassword) use these so
// labels and field text are the same size everywhere.
export const FORM_LABEL_CLASS = 'type-label text-charcoal-100'

// The fill-colour override stops Safari greying disabled values; placeholder needs `!` to beat the global input::placeholder rule.
export const FORM_DISABLED_TEXT_CLASS =
	'text-charcoal-800 placeholder:!text-charcoal-500 disabled:[-webkit-text-fill-color:theme(colors.charcoal.800)]'

export const FORM_INPUT_TEXT_CLASS = 'text-base'

// Rendered height of every single-line field (Input, SearchableSelect); buttons sharing a row with one must match it.
export const FORM_FIELD_HEIGHT_PX = 42
// Literal class string so Tailwind's scanner emits it; keep in step with FORM_FIELD_HEIGHT_PX.
export const FORM_FIELD_HEIGHT_CLASS = 'h-[42px]'
